const formatCurrency = (c: number) =>
  new Intl.NumberFormat("nb-NO", { style: "currency", currency: "NOK" }).format(c);

export default formatCurrency;
